import { createRoute } from '@tanstack/react-router';
import {
  VozidlaSpravaPage,
  parseVozidlaSpravaSearch,
} from '@/modules/vozidla/sprava/VozidlaSpravaPage';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/sprava',
  component: VozidlaSpravaPage,
  validateSearch: parseVozidlaSpravaSearch,
});
